export default __webpack_public_path__ + "static/media/pos-report.0c805124.jpg";